(function() {
  if (window.location.search.indexOf('adjust') === -1) return;

  var wrap = document.querySelector('.gate-logo-wrap');
  if (!wrap) return;

  // Inject styles
  var style = document.createElement('style');
  style.textContent = [
    '.dbg-handle {',
    '  position: absolute; width: 22px; height: 22px;',
    '  background: #ff0; border: 3px solid #000;',
    '  z-index: 10002; box-shadow: 0 0 8px rgba(0,0,0,0.6);',
    '  pointer-events: auto;',
    '}',
    '.dbg-handle-tl { top: -11px; left: -11px; cursor: nwse-resize; }',
    '.dbg-handle-tr { top: -11px; right: -11px; cursor: nesw-resize; }',
    '.dbg-handle-bl { bottom: -11px; left: -11px; cursor: nesw-resize; }',
    '.dbg-handle-br { bottom: -11px; right: -11px; cursor: nwse-resize; }',
    '.dbg-label {',
    '  position: absolute; bottom: 100%; left: 50%; transform: translateX(-50%);',
    '  margin-bottom: 6px;',
    '  font: bold 11px monospace; color: #ff0; background: rgba(0,0,0,0.85);',
    '  padding: 3px 8px; border-radius: 4px; white-space: nowrap;',
    '  pointer-events: none; z-index: 10002;',
    '}',
    '.dbg-outline { outline: 2px dashed #ff0; outline-offset: 2px; }',
    '.debug-toolbar {',
    '  position: fixed; bottom: 20px; right: 20px; z-index: 99999;',
    '  display: flex; gap: 10px;',
    '}',
    '.debug-btn {',
    '  background: #ff0; color: #000; border: none; padding: 14px 28px;',
    '  font: bold 15px monospace; border-radius: 8px; cursor: pointer;',
    '  box-shadow: 0 4px 14px rgba(0,0,0,0.4);',
    '}',
    '.debug-btn:hover { background: #ee0; }',
  ].join('\n');
  document.head.appendChild(style);

  // Wrap each sticker img in a positioned div with handles
  var stickerImgs = wrap.querySelectorAll('.gate-sticker');
  var stickerWraps = [];

  stickerImgs.forEach(function(img) {
    // Create wrapper div that takes over the sticker's position
    var div = document.createElement('div');
    div.style.position = 'absolute';
    div.style.zIndex = img.style.zIndex || '3';
    div.style.cursor = 'grab';
    div.style.userSelect = 'none';
    div.className = 'dbg-outline';

    // Copy computed position from img
    var cs = getComputedStyle(img);
    div.style.width = cs.width;
    div.style.top = cs.top;
    div.style.left = cs.left;
    div.style.right = cs.right;
    div.style.bottom = cs.bottom;

    // Insert wrapper, move img inside
    img.parentNode.insertBefore(div, img);
    div.appendChild(img);

    // Reset img positioning inside wrapper
    img.style.position = 'relative';
    img.style.width = '100%';
    img.style.height = 'auto';
    img.style.top = 'auto';
    img.style.left = 'auto';
    img.style.right = 'auto';
    img.style.bottom = 'auto';
    img.style.display = 'block';

    // Add 4 corner handles
    ['tl','tr','bl','br'].forEach(function(c) {
      var h = document.createElement('div');
      h.className = 'dbg-handle dbg-handle-' + c;
      h.dataset.corner = c;
      div.appendChild(h);
    });

    // Add label
    var label = document.createElement('div');
    label.className = 'dbg-label';
    div.appendChild(label);

    stickerWraps.push({ div: div, img: img, origClass: img.className });
  });

  // Drag & resize state
  var dragging = null;
  var resizeInfo = null;
  var dragStart = {};

  stickerWraps.forEach(function(sw) {
    var div = sw.div;

    // Drag from the image area
    div.addEventListener('mousedown', function(e) {
      if (e.target.classList.contains('dbg-handle')) return;
      e.preventDefault();
      dragging = div;
      div.style.cursor = 'grabbing';
      var wrapRect = wrap.getBoundingClientRect();
      var rect = div.getBoundingClientRect();
      dragStart = {
        mx: e.clientX, my: e.clientY,
        left: rect.left - wrapRect.left,
        top: rect.top - wrapRect.top
      };
    });

    // Resize from handles
    div.querySelectorAll('.dbg-handle').forEach(function(h) {
      h.addEventListener('mousedown', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var rect = div.getBoundingClientRect();
        var wrapRect = wrap.getBoundingClientRect();
        resizeInfo = {
          el: div,
          corner: h.dataset.corner,
          startX: e.clientX,
          startY: e.clientY,
          startW: rect.width,
          startH: rect.height,
          startLeft: rect.left - wrapRect.left,
          startTop: rect.top - wrapRect.top,
          aspect: rect.width / rect.height
        };
      });
    });
  });

  document.addEventListener('mousemove', function(e) {
    var wrapRect = wrap.getBoundingClientRect();

    if (dragging) {
      e.preventDefault();
      var dx = e.clientX - dragStart.mx;
      var dy = e.clientY - dragStart.my;
      dragging.style.left = (dragStart.left + dx) / wrapRect.width * 100 + '%';
      dragging.style.top = (dragStart.top + dy) / wrapRect.height * 100 + '%';
      dragging.style.right = 'auto';
      dragging.style.bottom = 'auto';
      updateLabels();
    }

    if (resizeInfo) {
      e.preventDefault();
      var r = resizeInfo;
      var dx = e.clientX - r.startX;
      var newW, newLeft, newTop;

      if (r.corner === 'br') {
        newW = r.startW + dx;
        newLeft = r.startLeft;
        newTop = r.startTop;
      } else if (r.corner === 'bl') {
        newW = r.startW - dx;
        newLeft = r.startLeft + dx;
        newTop = r.startTop;
      } else if (r.corner === 'tr') {
        newW = r.startW + dx;
        var newH = newW / r.aspect;
        newLeft = r.startLeft;
        newTop = r.startTop - (newH - r.startH);
      } else if (r.corner === 'tl') {
        newW = r.startW - dx;
        var newH2 = newW / r.aspect;
        newLeft = r.startLeft + (r.startW - newW);
        newTop = r.startTop - (newH2 - r.startH);
      }

      if (newW < 20) newW = 20;
      r.el.style.width = (newW / wrapRect.width * 100) + '%';
      r.el.style.left = (newLeft / wrapRect.width * 100) + '%';
      r.el.style.top = (newTop / wrapRect.height * 100) + '%';
      r.el.style.right = 'auto';
      r.el.style.bottom = 'auto';
      r.el.style.height = 'auto';
      updateLabels();
    }
  });

  document.addEventListener('mouseup', function() {
    if (dragging) dragging.style.cursor = 'grab';
    dragging = null;
    resizeInfo = null;
  });

  function updateLabels() {
    var wrapRect = wrap.getBoundingClientRect();
    stickerWraps.forEach(function(sw) {
      var rect = sw.div.getBoundingClientRect();
      var label = sw.div.querySelector('.dbg-label');
      if (!label) return;
      var l = ((rect.left - wrapRect.left) / wrapRect.width * 100).toFixed(1);
      var t = ((rect.top - wrapRect.top) / wrapRect.height * 100).toFixed(1);
      var w = (rect.width / wrapRect.width * 100).toFixed(1);
      label.textContent = 'W:' + w + '% | L:' + l + ' T:' + t;
    });
  }

  // Export button
  var toolbar = document.createElement('div');
  toolbar.className = 'debug-toolbar';
  document.body.appendChild(toolbar);

  var exportBtn = document.createElement('button');
  exportBtn.className = 'debug-btn';
  exportBtn.textContent = 'EXPORT POSITIONS';
  toolbar.appendChild(exportBtn);

  exportBtn.addEventListener('click', function() {
    var wrapRect = wrap.getBoundingClientRect();
    var output = '/* EXPORTED STICKER POSITIONS */\n\n';
    var classes = ['gate-sticker-thc', 'gate-sticker-smiley', 'gate-sticker-cals', 'gate-sticker-leaf'];
    var names = ['THC', 'Smiley', 'Cals', 'Leaf'];

    stickerWraps.forEach(function(sw, i) {
      var rect = sw.div.getBoundingClientRect();
      var l = ((rect.left - wrapRect.left) / wrapRect.width * 100).toFixed(1);
      var t = ((rect.top - wrapRect.top) / wrapRect.height * 100).toFixed(1);
      var w = (rect.width / wrapRect.width * 100).toFixed(1);

      output += '/* ' + names[i] + ' */\n';
      output += '.' + classes[i] + ' {\n';
      output += '  width: ' + w + '%;\n';
      output += '  top: ' + t + '%;\n';
      output += '  left: ' + l + '%;\n';
      output += '}\n\n';
    });

    navigator.clipboard.writeText(output).then(function() {
      exportBtn.textContent = 'COPIED!';
      exportBtn.style.background = '#0f0';
      setTimeout(function() {
        exportBtn.textContent = 'EXPORT POSITIONS';
        exportBtn.style.background = '#ff0';
      }, 2000);
    });
    console.log(output);
  });

  setTimeout(updateLabels, 500);
})();
